// extracted by mini-css-extract-plugin
export default {"root":"card-resource-container_root__NrG5j"};